import {AppProps} from "next/app";
import {wrapper} from "@/store/store";
import {Provider} from "react-redux";
import {ThemeProvider} from "styled-components";
import theme from "@/styles/themes/index";
import GlobalStyle from "@/styles/default";
import Loading from "@/components/loading";
import {useEffect, useMemo, useState} from "react";
import {InitLoadEvents} from "@/utils/Events";
import Apm from "@/utils/Apm";
import {StatsigProvider} from "@statsig/react-bindings";
import {StatsigAutoCapturePlugin} from "@statsig/web-analytics";

export default function App({Component, ...rest}: AppProps) {
    const {store, props} = wrapper.useWrappedStore(rest)
    const {pageProps} = props;
    const [mounted, setMounted] = useState(false)

    Apm.init();

    useEffect(() => {
        setMounted(true)
    }, [])

    useEffect(() => {
        InitLoadEvents();
    }, [])

    useEffect(() => {
        function handleError(event: ErrorEvent) {
            Apm.captureError(`GLOBAL_ERROR: ${event.error}`)
        }

        window.addEventListener("error", handleError);
        return () => window.removeEventListener("error", handleError);
    }, [])


    const statsigOptions = useMemo(() => ({
        environment: {
            tier: 'production'
        },
        plugins: [new StatsigAutoCapturePlugin()]
    }), [])

    const content = (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <Loading></Loading>
                <GlobalStyle></GlobalStyle>
                <div className={'container'}>
                    <Component {...pageProps}></Component>
                </div>
            </ThemeProvider>
        </Provider>
    )

    if (!mounted) {
        return content
    }

    return (
        <StatsigProvider sdkKey={process.env.NEXT_PUBLIC_STATSIG_CLIENT_KEY ?? ''} user={{}} options={statsigOptions}>
            {content}
        </StatsigProvider>
    )
}